import store from '../store/store'
import {GraphQLErrors, NetworkError} from '../actions/error-actions'

export const setGraphQLErrors = (error, operation) => {
  store.dispatch(GraphQLErrors(error, operation))
}

export const setNetworkError = (error, operation) => {
  store.dispatch(NetworkError(error, operation))
}



// WEBPACK FOOTER //
// ./src/utils/errorHandler.js